"use strict"; // Copyright (c) Jupyter Development Team.
// Distributed under the terms of the Modified BSD License.

var _classCallCheck = require("/opt/build/repo/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/opt/build/repo/node_modules/@babel/runtime/helpers/createClass");

var _inherits = require("/opt/build/repo/node_modules/@babel/runtime/helpers/inherits");

var _possibleConstructorReturn = require("/opt/build/repo/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/opt/build/repo/node_modules/@babel/runtime/helpers/getPrototypeOf");

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

Object.defineProperty(exports, "__esModule", {
  value: true
});

var disposable_1 = require("@phosphor/disposable");

var messages_1 = require("./messages");
/**
 * Comm channel handler.
 */


var CommHandler = /*#__PURE__*/function (_disposable_1$Disposa) {
  _inherits(CommHandler, _disposable_1$Disposa);

  var _super = _createSuper(CommHandler);

  /**
   * Construct a new comm channel.
   */
  function CommHandler(target, id, kernel, disposeCb) {
    var _this;

    _classCallCheck(this, CommHandler);

    _this = _super.call(this, disposeCb);
    _this._target = '';
    _this._id = '';
    _this._id = id;
    _this._target = target;
    _this._kernel = kernel;
    return _this;
  }
  /**
   * The unique id for the comm channel.
   */


  _createClass(CommHandler, [{
    key: "commId",
    get: function get() {
      return this._id;
    }
    /**
     * The target name for the comm channel.
     */

  }, {
    key: "targetName",
    get: function get() {
      return this._target;
    }
    /**
     * Get the callback for a comm close event.
     *
     * #### Notes
     * This is called when the comm is closed from either the server or client.
     *
     * **See also:** [[ICommClose]], [[close]]
     */

  }, {
    key: "onClose",
    get: function get() {
      return this._onClose;
    }
    /**
     * Set the callback for a comm close event.
     *
     * #### Notes
     * This is called when the comm is closed from either the server or client. If
     * the function returns a promise, and the kernel was closed from the server,
     * kernel message processing will pause until the returned promise is
     * fulfilled.
     *
     * **See also:** [[close]]
     */
    ,
    set: function set(cb) {
      this._onClose = cb;
    }
    /**
     * Get the callback for a comm message received event.
     */

  }, {
    key: "onMsg",
    get: function get() {
      return this._onMsg;
    }
    /**
     * Set the callback for a comm message received event.
     *
     * #### Notes
     * This is called when a comm message is received. If the function returns a
     * promise, kernel message processing will pause until it is fulfilled.
     */
    ,
    set: function set(cb) {
      this._onMsg = cb;
    }
    /**
     * Open a comm with optional data and metadata.
     *
     * #### Notes
     * This sends a `comm_open` message to the server.
     *
     * **See also:** [[ICommOpen]]
     */

  }, {
    key: "open",
    value: function open(data, metadata) {
      var buffers = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : [];

      if (this.isDisposed || this._kernel.isDisposed) {
        throw new Error('Cannot open');
      }

      var options = {
        msgType: 'comm_open',
        channel: 'shell',
        username: this._kernel.username,
        session: this._kernel.clientId
      };
      var content = {
        comm_id: this._id,
        target_name: this._target,
        data: data || {}
      };
      var msg = messages_1.KernelMessage.createShellMessage(options, content, metadata, buffers);
      return this._kernel.sendShellMessage(msg, false, true);
    }
    /**
     * Send a `comm_msg` message to the kernel.
     *
     * #### Notes
     * This is a no-op if the comm has been closed.
     *
     * **See also:** [[ICommMsg]]
     */

  }, {
    key: "send",
    value: function send(data, metadata) {
      var buffers = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : [];
      var disposeOnDone = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : true;

      if (this.isDisposed || this._kernel.isDisposed) {
        throw new Error('Cannot send');
      }

      var options = {
        msgType: 'comm_msg',
        channel: 'shell',
        username: this._kernel.username,
        session: this._kernel.clientId
      };
      var content = {
        comm_id: this._id,
        data: data
      };
      var msg = messages_1.KernelMessage.createShellMessage(options, content, metadata, buffers);
      return this._kernel.sendShellMessage(msg, false, true);
    }
    /**
     * Close the comm.
     *
     * #### Notes
     * This will send a `comm_close` message to the kernel, and call the
     * `onClose` callback if set.
     *
     * This is a no-op if the comm is already closed.
     *
     * **See also:** [[ICommClose]], [[onClose]]
     */

  }, {
    key: "close",
    value: function close(data, metadata) {
      var buffers = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : [];

      if (this.isDisposed || this._kernel.isDisposed) {
        throw new Error('Cannot close');
      }

      var options = {
        msgType: 'comm_msg',
        channel: 'shell',
        username: this._kernel.username,
        session: this._kernel.clientId
      };
      var content = {
        comm_id: this._id,
        data: data || {}
      };
      var msg = messages_1.KernelMessage.createShellMessage(options, content, metadata, buffers);

      var future = this._kernel.sendShellMessage(msg, false, true);

      options.channel = 'iopub';
      var onClose = this._onClose;

      if (onClose) {
        var ioMsg = messages_1.KernelMessage.createMessage(options, content, metadata, buffers); // In the future, we may want to communicate back to the user the possible
        // promise returned from onClose.

        onClose(ioMsg);
      }

      this.dispose();
      return future;
    }
  }]);

  return CommHandler;
}(disposable_1.DisposableDelegate);

exports.CommHandler = CommHandler;